/**
 * @fileoverview Index file for conversational agents.
 *
 * Conversational agents are stateful, multi-turn chat flows that use
 * tool calling and streaming. They sit alongside `primitives/` and
 * `composites/` rather than inside them because they differ in nearly
 * every axis from the primitive-agent template (no Handlebars macros,
 * no structured output schema, tools + message arrays instead of
 * context variables, streaming UI contract).
 *
 * ## Import boundary
 * This barrel deliberately imports only the `definition` modules — NOT
 * the co-located `flow.ts` files. The agent registry (`definitions.ts`)
 * only needs metadata; pulling in flow.ts would transitively register
 * Genkit tools at module load, which breaks any unit test that mocks
 * `@/ai/genkit` without stubbing `defineTool`. Runtime registration of
 * the flow itself happens via the per-agent barrel, imported only from
 * `src/ai/dev.ts` and the chat API route.
 *
 * @see ../primitives/index.ts for the primitive-agent template.
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { definition as chatWithStoryV1 } from './chat-with-story/definition';

export { chatWithStoryV1 };

export const CONVERSATIONAL_AGENT_DEFINITIONS: AppAgentDefinition[] = [
  chatWithStoryV1,
];
